<!-- // ============================================
// 9. ProductOrders.vue
// ============================================ -->
<template>
    <div v-if="orders && orders.length > 0" class="info-block">
        <h3>{{ $t('product.orders') }}</h3>
        <div class="table-responsive">
            <table class="table modern-table">
                <tbody>
                    <tr v-for="order in orders" :key="order.id">
                        <td>{{ maskEmail(order.user.email) }}</td>
                        <td class="bid-price">{{ formatPrice(order.price) }}</td>
                        <td>{{ order.created_at | moment }}</td>
                        <td>
                            <span class="badge" :class="getStatusClass(order.status)">
                                {{ getStatusLabel(order.status) }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import helper from "@/services/helper";

export default {
    name: 'ProductOrders',
    props: {
        orders: {
            type: Array,
            required: true
        }
    },
    methods: {
        formatPrice: helper.formatPrice,
        maskEmail: helper.maskEmail,
        getStatusLabel(status) {
            const statuses = {
                pending: this.$t('orderStatus.pending') || 'En attente',
                confirmed: this.$t('orderStatus.confirmed') || 'Confirmée',
                shipped: this.$t('orderStatus.shipped') || 'Expédiée',
                delivered: this.$t('orderStatus.delivered') || 'Livrée',
                completed: this.$t('orderStatus.completed') || 'Terminée',
                cancelled: this.$t('orderStatus.cancelled') || 'Annulée'
            };
            return statuses[status] || status;
        },
        getStatusClass(status) {
            const classes = {
                pending: 'badge-warning',
                confirmed: 'badge-info',
                shipped: 'badge-primary',
                delivered: 'badge-success',
                completed: 'badge-success',
                cancelled: 'badge-danger'
            };
            return classes[status] || 'badge-secondary';
        }
    }
};
</script>
/* ============================================
   9. ProductOrders.vue
   ============================================ */
<style scoped>
.info-block {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-bottom: 30px;
    border-bottom: 1px solid #e8e8e8;
}

.info-block h3 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    color: var(--color-3);
}

.table-responsive {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.modern-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    margin: 0;
}

.modern-table tbody tr {
    transition: all 0.2s ease;
    border-bottom: 1px solid var(--gray-100);
}

.modern-table tbody tr:last-child {
    border-bottom: none;
}

.modern-table tbody tr:hover {
    background: var(--gray-50);
    transform: scale(1.001);
}

.modern-table td {
    padding: 18px 20px;
    vertical-align: middle;
    border: none;
    color: var(--gray-700);
    font-size: 14px;
}

.modern-table td:first-child {
    font-weight: 600;
    color: var(--gray-800);
}

.bid-price {
    font-size: 1.125rem;
    font-weight: 700;
    color: #1f2937;
}

.badge {
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
}

.badge-warning {
    background: #fff3cd;
    color: #856404;
}

.badge-info {
    background: #d1ecf1;
    color: #0c5460;
}

.badge-primary {
    background: #cce5ff;
    color: #004085;
}

.badge-success {
    background: #d4edda;
    color: #155724;
}

.badge-danger {
    background: #f8d7da;
    color: #721c24;
}

.badge-secondary {
    background: #e2e3e5;
    color: #383d41;
}

@media (max-width: 768px) {
    .modern-table td {
        padding: 12px 16px;
        font-size: 13px;
    }
}
</style>
